import { Platform, useWindowDimensions } from 'react-native';
import { spacing } from '../../../shared/theme/spacing';
import { WEB_SIDEBAR_BREAKPOINT } from '../../../shared/layout/breakpoints';

const DESKTOP_TYPE_GRID_COLUMNS = 3 as const;

export type OnboardingLayout = {
  isWide: boolean;
  typeGridColumns: 2 | 3;
  typeGridGap: number;
  cardMaxWidth: number;
  cardPadding: number;
  useSplitLayout: boolean;
  contentPadding: number;
  typeCardPadding: number;
  typeIconBoxSize: number;
  typeIconGlyphSize: number;
  typeTitleFontSize: number;
  typeTitleLineHeight: number;
};

function resolveCardMaxWidth(isWide: boolean, width: number): number {
  if (!isWide) return width;
  if (width >= 1536) return Math.min(1200, width - 80);
  if (width >= 1280) return 1080;
  if (width >= 1024) return 960;
  return 840;
}

export function useOnboardingLayout(): OnboardingLayout {
  const { width } = useWindowDimensions();
  // Misma breakpoint que login C / proto desktop.
  const isWide = width >= WEB_SIDEBAR_BREAKPOINT;
  const useSplitLayout = isWide && Platform.OS === 'web';
  const cardMaxWidth = resolveCardMaxWidth(isWide, width);
  const cardPadding = !isWide
    ? spacing.lg
    : isWide && width >= 1280
      ? spacing.xxl
      : spacing.xl;

  return {
    isWide,
    typeGridColumns: isWide ? DESKTOP_TYPE_GRID_COLUMNS : 2,
    typeGridGap: isWide ? spacing.md : spacing.sm,
    cardMaxWidth,
    cardPadding,
    useSplitLayout,
    contentPadding: isWide ? spacing.xl : 0,
    typeCardPadding: isWide ? spacing.md : spacing.sm,
    typeIconBoxSize: isWide ? 32 : 36,
    typeIconGlyphSize: isWide ? 18 : 20,
    typeTitleFontSize: 13,
    typeTitleLineHeight: isWide ? 16 : 17,
  };
}
